<div class="content-header pt-4 pb-2">
    <div class="container-fluid">
        <div class="row align-items-center mb-3">
            <div class="col-sm-6 d-flex align-items-center">
                <h1 class="m-0 text-light mr-2 page-title">Categories</h1>
                <button type="button" class="btn btn-primary btn-add" (click)="openAddModal()">
                    <i class="fas fa-plus"></i>
                </button>
            </div>
            <div class="col-sm-6">
                <!-- <ol class="breadcrumb float-sm-right"> ... </ol> hidden to match mockup simplicity -->
            </div>
        </div>
    </div>
</div>

<section class="content">
    <div class="container-fluid">
        <!-- Floating white table container (matches mockup) -->
        <div class="mockup-table-container">
            <table class="table table-hover table-borderless text-center align-middle empty-table">
                <thead>
                    <tr>
                        <th width="10%">Sr.No</th>
                        <th width="20%">Image</th>
                        <th width="45%">Category Name</th>
                        <th width="25%">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Loading state handled via ngx-spinner exclusively now per user design,
                         but we can leave empty state text -->
                    <tr *ngIf="!isLoading && categories.length === 0">
                        <td colspan="4" class="text-muted py-4">No categories found. Add a new category to get started.
                        </td>
                    </tr>

                    <!-- Data rows -->
                    <tr *ngFor="let cat of categories; let i = index">
                        <td class="text-muted">{{ i + 1 }}</td>
                        <td>
                            <img *ngIf="cat.categoryImage" [src]="cat.categoryImage" alt="Category Image"
                                style="max-height: 50px; border-radius: 4px; border: 1px solid #eee;">
                            <span *ngIf="!cat.categoryImage" class="text-muted small">No Image</span>
                        </td>
                        <td class="font-weight-bold text-dark">{{ cat.categoryName }}</td>
                        <td class="action-icons">
                            <a href="javascript:void(0)" class="text-success mx-2" title="View"><i
                                    class="fas fa-eye"></i></a>
                            <a href="javascript:void(0)" class="text-primary mx-2" title="Edit"
                                (click)="openEditModal(cat)"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<!-- Add / Edit Modal Overlay -->
<div class="custom-modal-backdrop" *ngIf="isModalOpen">
    <div class="custom-modal">
        <div class="custom-modal-header">
            <h5 class="m-0">{{ isEditMode ? 'Edit Category' : 'Add New Category' }}</h5>
            <button class="close-btn" (click)="closeModal()">&times;</button>
        </div>
        <div class="custom-modal-body">
            <form [formGroup]="categoryForm" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <label>Category Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="categoryName"
                        placeholder="Enter category name">
                    <span class="text-danger font-weight-bold" style="font-size: 12px"
                        *ngIf="categoryFormErrors.categoryName">
                        {{categoryFormErrors.categoryName}}
                    </span>
                </div>

                <div class="form-group">
                    <label>Category Image URL (Optional)</label>
                    <input type="text" class="form-control" formControlName="categoryImage"
                        placeholder="Upload or enter URL">
                </div>

                <div class="custom-modal-footer mt-4 text-right">
                    <button type="button" class="btn btn-secondary mr-2" (click)="closeModal()">Cancel</button>
                    <button type="submit" class="btn btn-primary">
                        {{ isEditMode ? 'Update' : 'Save' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>